import React from 'react'
import { useIntl } from 'react-intl'
import { CANCEL } from 'app/constants/button'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { DIALOG_KEYS } from '../constants'

const DeleteSubscriberFromGroup = () => {
  const { formatMessage } = useIntl()
  const { dialogState, closeDialog } = useGroupDialog()
  const { open, action, isLoading } =
    dialogState[DIALOG_KEYS.DELETE_SUBSCRIBER_FROM_GROUP]

  const handleSubmit = () => {
    action?.onSubmit?.()
  }

  return (
    <SubmitDialog
      id="dialog-delete-subgroup"
      open={open}
      type={CANCEL}
      title={`${formatMessage({ id: action?.subscriberIds.length > 1 ? 'groupsv4.remove.subscriber.title' : 'groupsv4.remove.subscriber.title.single' })}?`}
      description={formatMessage({
        id:
          action?.subscriberIds.length > 1
            ? 'groupsv4.remove.subscriber.description'
            : 'groupsv4.remove.subscriber.description.single',
      })}
      isLoading={isLoading}
      submitText={formatMessage({
        id: 'action.remove',
      })}
      onSubmit={handleSubmit}
      closeText={formatMessage({
        id: 'text.close',
      })}
      onClose={() => closeDialog(DIALOG_KEYS.DELETE_SUBSCRIBER_FROM_GROUP)}
    />
  )
}

export default DeleteSubscriberFromGroup
